import { LogoContainerStyle } from "./Components";
import { LinkStyle } from "./Components";

import InstagramIcon from "../../assets/icons/instagram.svg";
import FacebookIcon from "../../assets/icons/facebook.svg";
import YoutubeIcon from "../../assets/icons/youtube.svg";
import LinkedinIcon from "../../assets/icons/linkedin.svg";

export default function Footer() {
  return (
    <>
      <LogoContainerStyle>
        <div className="logoContainer">
          <LinkStyle href="https://www.instagram.com/md_iit_dhanbad/">
            <img src={InstagramIcon} alt="instagram" />
          </LinkStyle>
          <LinkStyle href="https://x.facebook.com/MDiitism/">
            <img src={FacebookIcon} alt="facebook" />
          </LinkStyle>
          <LinkStyle href="https://www.youtube.com/channel/UCrcdJ3AGxugb7X2k5uadBFg">
            <img src={YoutubeIcon} alt="youtube" />
          </LinkStyle>
          <LinkStyle href="https://www.linkedin.com/company/mailer-daemon/">
            <img src={LinkedinIcon} alt="linkedin" />
          </LinkStyle>
        </div>
      </LogoContainerStyle>
    </>
  );
}
